module.exports = "<div class=\"navbar-header\">\r\n\r\n    <img class=\"logo-icon\" style=\"cursor:pointer;width: 70%;\" (click)=\"goHome()\" [src]=\"foto\">\r\n\r\n</div>\r\n\r\n<div class=\"navbar-content\" fusePerfectScrollbar>\r\n    <fuse-navigation layout=\"vertical\"></fuse-navigation>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/navbar/vertical/navbar-vertical.component.html
// module id = ./src/app/main/navbar/vertical/navbar-vertical.component.html
// module chunks = main